import {
  V2ResourceRateResource,
  useV2ListResourceRatesForAccountQuery,
} from "@generated";

// Only the rates on the project's rate table. Without a rate table id there is
// nothing to filter by, so skip rather than list every rate on the account.
const useListResourceRates = (rateTableId: string | undefined) => {
  const { data, error, isLoading, refetch } =
    useV2ListResourceRatesForAccountQuery(
      {
        page: { size: 1000 },
        filter: { "rate-table": rateTableId ?? "" },
        include: ["resource", "line-of-business"],
      },
      { skip: !rateTableId }
    );

  let resourceRates: V2ResourceRateResource[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      resourceRates = data?.data;

      if (!data?.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data?.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data?.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data?.meta["record-count"],
        pageCount: data?.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    resourceRates,
    resourceRatesError: error || customError,
    resourceRatesLoading: isLoading,
    pageMeta,
    resourceRatesRefetch: refetch,
  };
};

export default useListResourceRates;
